// /* eslint-disable no-unsafe-optional-chaining */
// import { useEffect } from 'react';
// import { useAppDispatch, useAppSelector } from '@store/hooks';
// import { getApBankAccountsList } from '@store/Finance/AP/ApBankAccounts/ApBankAccountsSlice';
// import { useTranslation } from 'react-i18next';

// const useGetBankAccountsList = () => {
//   const dispatch = useAppDispatch();
//   const { t, i18n } = useTranslation();

//   useEffect(() => {
//     if (ApBankAccountsList?.length === 0) {
//       dispatch(getApBankAccountsList());
//     }
//   }, []);
//   const { ApBankAccountsList, loading, error } = useAppSelector(state => state.ApBankAccounts);

//   console.log(ApBankAccountsList);
  

//   const BankAccountsList = ApBankAccountsList;

//   const OptionsBankAccounts =
//     BankAccountsList &&
//     BankAccountsList?.map(item => ({
//       value: item.id,
//       label: i18n.language === 'ar' ? item.name2 : item.name
//     }));

//   const grouped = BankAccountsList?.reduce((groups: any, bank: any) => {
//     const bankGroup = groups?.find((group: any) => group.label === bank.ntxBankName);
//     if (bankGroup) {
//       // If the bank group already exists, add the branch to it
//       bankGroup?.options?.push({ value: bank.id, label: bank.name });
//     } else {
//       // If the bank group does not exist, create a new group
//       groups?.push({
//         ntxBankId: bank.ntxBankId,
//         label: bank.ntxBankName,
//         options: [{ value: bank.id, label: bank.name }]
//       });
//     }
//     return groups;
//   }, []);

//   // ترتيب القائمة لتأتي الصناديق النقدية في البداية
//   const groupedOptions = [
//     grouped?.find((f: any) => f.ntxBankId === 'f700cf22-af84-4ca2-ac8c-c3bef5b88325'),
//     ...grouped?.filter((f: any) => f.ntxBankId !== 'f700cf22-af84-4ca2-ac8c-c3bef5b88325')
//   ];

//   return { BankAccountsList, OptionsBankAccounts, groupedOptions, loading, error };
// };

// export default useGetBankAccountsList;


// /* eslint-disable no-unsafe-optional-chaining */
// import { useEffect, useMemo, useRef } from 'react';
// import { useAppDispatch, useAppSelector } from '@store/hooks';
// import { getApBankAccountsList } from '@store/Finance/AP/ApBankAccounts/ApBankAccountsSlice';
// import { useTranslation } from 'react-i18next';

// const CASH_BANK_ID = 'f700cf22-af84-4ca2-ac8c-c3bef5b88325';

// const getOrgIdFromRow = (row: any) =>
//   row?.organizationId ?? row?.ntxOrganizationId ?? row?.operatingUnitId ?? row?.ouId ?? row?.orgId ?? null;

// const useGetBankAccountsList = (organizationId?: string) => {
//   const dispatch = useAppDispatch();
//   const { i18n } = useTranslation();

//   const { ApBankAccountsList = [], loading, error } = useAppSelector(
//     state => state.ApBankAccounts
//   );

//   // ✅ لتفادي إعادة الجلب لنفس orgId
//   const lastOrgIdRef = useRef<string | null>(null);

//   useEffect(() => {
//     const currentOrgId = organizationId ?? null;

//     // إذا ما عندنا بيانات أو تغير orgId -> اجلب
//     const shouldFetch =
//       ApBankAccountsList.length === 0 || lastOrgIdRef.current !== currentOrgId;

//     if (!shouldFetch) return;

//     lastOrgIdRef.current = currentOrgId;

//     // ✅ إذا الـ thunk عندك يدعم باراميتر organizationId
//     // dispatch(getApBankAccountsList({ organizationId }));

//     // ✅ إذا ما يدعم، اتركه بدون باراميتر (ويتم الفلترة محلياً)
//     dispatch(getApBankAccountsList() as any);
//   }, [dispatch, organizationId]); // لا تضف ApBankAccountsList لتجنب loop

//   // ✅ فلترة محلية حسب organizationId (إن وجد)
//   const BankAccountsList = useMemo(() => {
//     if (!organizationId) return ApBankAccountsList;

//     return (ApBankAccountsList || []).filter((x: any) => getOrgIdFromRow(x) === organizationId);
//   }, [ApBankAccountsList, organizationId]);

//   const OptionsBankAccounts = useMemo(() => {
//     return (BankAccountsList || []).map((item: any) => ({
//       value: item.id,
//       label: i18n.language === 'ar' ? (item.name2 ?? item.name) : (item.name ?? item.name2)
//     }));
//   }, [BankAccountsList, i18n.language]);

//   const grouped = useMemo(() => {
//     return (BankAccountsList || []).reduce((groups: any[], bank: any) => {
//       const groupLabel =
//         i18n.language === 'ar'
//           ? (bank.ntxBankName2 ?? bank.ntxBankName)
//           : (bank.ntxBankName ?? bank.ntxBankName2);

//       const optionLabel =
//         i18n.language === 'ar' ? (bank.name2 ?? bank.name) : (bank.name ?? bank.name2);

//       const bankGroup = groups.find((group: any) => group.label === groupLabel);

//       if (bankGroup) {
//         bankGroup.options.push({ value: bank.id, label: optionLabel });
//       } else {
//         groups.push({
//           ntxBankId: bank.ntxBankId,
//           label: groupLabel,
//           options: [{ value: bank.id, label: optionLabel }]
//         });
//       }
//       return groups;
//     }, []);
//   }, [BankAccountsList, i18n.language]);

//   // ✅ ترتيب: الصناديق النقدية أولاً (مع إزالة undefined)
//   const groupedOptions = useMemo(() => {
//     const cashGroup = grouped?.find((f: any) => f.ntxBankId === CASH_BANK_ID);
//     const rest = (grouped || []).filter((f: any) => f.ntxBankId !== CASH_BANK_ID);
//     return [cashGroup, ...rest].filter(Boolean);
//   }, [grouped]);

//   return { BankAccountsList, OptionsBankAccounts, groupedOptions, loading, error };
// };

// export default useGetBankAccountsList;


/* eslint-disable no-unsafe-optional-chaining */
import { useEffect, useMemo, useRef } from 'react';
import { useAppDispatch, useAppSelector } from '@store/hooks';
import { getApBankAccountsList } from '@store/Finance/AP/ApBankAccounts/ApBankAccountsSlice';
import { useTranslation } from 'react-i18next';

const CASH_BANK_ID = 'f700cf22-af84-4ca2-ac8c-c3bef5b88325';

const getOrgIdFromRow = (row: any) =>
  row?.organizationId ?? row?.ntxOrganizationId ?? row?.operatingUnitId ?? row?.ouId ?? row?.orgId ?? null;

// ✅ عشان نجيب الـ option المختار من داخل الـ groups
export const findOptionInGroups = (groups: any[], value: any) => {
  if (!value) return null;
  for (const g of groups || []) {
    const opt = g?.options?.find((o: any) => o?.value === value);
    if (opt) return opt;
  }
  return null;
};

const useGetBankAccountsList = (organizationId?: string) => {
  const dispatch = useAppDispatch();
  const { i18n } = useTranslation();

  const { ApBankAccountsList = [], loading, error } = useAppSelector(state => state.ApBankAccounts);

  const lastOrgIdRef = useRef<string | null>(null);

  useEffect(() => {
    const currentOrgId = organizationId ?? null;

    const shouldFetch = ApBankAccountsList.length === 0 || lastOrgIdRef.current !== currentOrgId;
    if (!shouldFetch) return;

    lastOrgIdRef.current = currentOrgId;

    // لو الـ thunk يدعم orgId فعلاً:
    // dispatch(getApBankAccountsList({ organizationId }));

    dispatch(getApBankAccountsList() as any);
  }, [dispatch, organizationId]); // لا تضف ApBankAccountsList لتجنب loop

  const BankAccountsList = useMemo(() => {
    if (!organizationId) return ApBankAccountsList;
    return (ApBankAccountsList || []).filter((x: any) => getOrgIdFromRow(x) === organizationId);
  }, [ApBankAccountsList, organizationId]);

  const OptionsBankAccounts = useMemo(() => {
    return (BankAccountsList || []).map((item: any) => ({
      value: item.id,
      label: i18n.language === 'ar' ? (item.name2 ?? item.name) : (item.name ?? item.name2),
      organizationId: getOrgIdFromRow(item)
    }));
  }, [BankAccountsList, i18n.language]);

  const grouped = useMemo(() => {
    return (BankAccountsList || []).reduce((groups: any[], bank: any) => {
      const groupLabel =
        i18n.language === 'ar'
          ? (bank.ntxBankName2 ?? bank.ntxBankName)
          : (bank.ntxBankName ?? bank.ntxBankName2);

      const optionLabel =
        i18n.language === 'ar' ? (bank.name2 ?? bank.name) : (bank.name ?? bank.name2);

      const bankGroup = groups.find((group: any) => group.label === groupLabel);

      if (bankGroup) {
        bankGroup.options.push({ value: bank.id, label: optionLabel });
      } else {
        groups.push({
          ntxBankId: bank.ntxBankId,
          label: groupLabel,
          options: [{ value: bank.id, label: optionLabel }]
        });
      }
      return groups;
    }, []);
  }, [BankAccountsList, i18n.language]);

  const groupedCashOptions = useMemo(() => {
    return (grouped || []).filter((g: any) => g?.ntxBankId === CASH_BANK_ID);
  }, [grouped]);

  const groupedBankOptions = useMemo(() => {
    return (grouped || []).filter((g: any) => g?.ntxBankId !== CASH_BANK_ID);
  }, [grouped]);

  // (اختياري) ترتيب: الصناديق أولاً ثم البنوك
  const groupedOptions = useMemo(() => {
    const cash = groupedCashOptions?.[0];
    return [cash, ...groupedBankOptions].filter(Boolean);
  }, [groupedCashOptions, groupedBankOptions]);

  return {
    BankAccountsList,
    OptionsBankAccounts,
    groupedOptions,
    groupedCashOptions,
    groupedBankOptions,
    loading,
    error
  };
};

export default useGetBankAccountsList;
